<template>
  <main>
    <Trail
      :list="[
        {
          path: '/proyectos/investigacion',
          name: 'Projects',
          tag: 'Proyectos de Investigación'
        },
        {
          name:
            'Influencia de los ecosistemas andinos en la erosión y conservación de los suelos, e identificación de su rol en la regulación del recurso hídrico en grandes ciudades altoandinas',
          tag:
            'Influencia de los ecosistemas andinos en la erosión y conservación de los suelos, e identificación de su rol en la regulación del recurso hídrico en grandes ciudades altoandinas'
        }
      ]"
    />
    <Container class="container--main">
      <Title tag="h1" align="center">
        Influencia de los ecosistemas andinos en la erosión y conservación de
        los suelos, e identificación de su rol en la regulación del recurso
        hídrico en grandes ciudades altoandinas
      </Title>
      <Row>
        <ColumnUi md="9">
          <Navtab id="introduccion">
            <Title tag="h2">Introducción</Title>
            <p>
              Cada año, durante la época de estiaje, la disponibilidad del
              recurso hídrico es crítica y altamente dependiente de los
              ecosistemas andinos ubicados en las cabeceras de cuencas.
              Recientes estudios científicos identificaron la importancia de los
              ecosistemas Andinos en la dinámica del recurso hídrico en las
              cabeceras de cuencas. Sin embargo, existen aspectos relevantes
              entre la interacción agua-suelo-planta los cuales son pobremente
              entendidos, ejemplo la influencia de los ecosistemas Andinos en la
              conservación y erosión de los suelos.
            </p>
            <p>
              Los Páramos son ecosistemas altamente resistentes a las
              variaciones climáticas. Dichas propiedades deben principalmente a
              la profundidad de sus suelos tipo Andosol, así como la gran
              acumulación de materia orgánica y a la morfología de ciertas
              plantas herbáceas del páramo. No obstante, los páramos andinos son
              altamente vulnerables al cambio del uso del suelo. Tovar, et al.,
              revelan cifras alarmantes del cambio del uso del suelo en
              Cajamarca. Durante 20 años (1987-2007) se han perdido el 30 % de
              la Jalca y el 56 % de forestales y matorrales. El escenario actual
              se tornará aún más crítico en el presente siglo como resultado del
              cambio climático y el calentamiento global, ya que dichas áreas se
              convierten en zonas altamente vulnerables a la erosión y
              degradación de los suelos.
            </p>
            <p>
              Con el fin de proteger a los ecosistemas Páramos de Piura y
              Cajamarca, en el año 2011, tres proyectos de Ley fueron formulados
              y presentados al Congreso de la República. No obstante, debido a
              la carencia de un sustento técnico sobre los servicios ambientales
              que proveen los Páramos, dichos proyectos fueron rechazados y
              posteriormente archivados.
            </p>
            <p>
              Las actividades en el presente proyecto se orientan a: i)
              identificar el rol de los páramos andinos en la regulación del
              recurso hídrico; y ii) establecer la influencia del Páramo en la
              conservación y erosión de los suelos andinos. Para cumplir con
              ambos objetivos, se implementó una densa red de monitoreo de alta
              precisión con registros a una alta escala temporal; complementario
              a ello se viene tomando lecturas de la concentración de isótopos
              en el suelo y el agua.
            </p>
          </Navtab>
          <Navtab id="laboratorio-experimental">
            <Title tag="h2">
              Laboratorio experimental de ecosistemas andinos
            </Title>
          </Navtab>
          <Navtab id="sitio-estudio">
            <Title tag="h2"> Sitio de estudio </Title>figure
            <Figure right="sm" maxWidth="700px">
              <Image
                :srcsets="[
                  '/images/proyectos/ecosistemas/mapa_ubicacion_web_170226.png'
                ]"
                title="Ubicación de la cuenca del río Ronquillo en el Perú. Distribución altitudinal de las estaciones meteorológicas e hidrológicas en la cuenca Ronquillo. A la fecha se cuentan con el primer año de registro de información a una alta resolución temporal y espacial"
              />
              <template #figcaption>
                <b>Figura 1</b>. Ubicación de la cuenca del río Ronquillo en el
                Perú. Distribución altitudinal de las estaciones meteorológicas
                e hidrológicas en la cuenca Ronquillo. A la fecha se cuentan con
                el primer año de registro de información a una alta resolución
                temporal y espacial.
              </template>
            </Figure>
            <p>
              Cajamarca es el departamento andino más poblado del Perú con
              1’513,892.00 habitantes según la proyección del INEI hacia el
              2012. La imponente ciudad de Cajamarca se encuentra en la cabecera
              de cuenca (2750 msnm), dicha característica la hace altamente
              vulnerable a la disponibilidad del recurso hídrico. Cajamarca
              presentó una explosión demográfica desde 1995 y mantiene su
              tendencia hasta actualidad; el impacto de dicho fenómeno de
              refleja en la fuerte presión sobre los recursos hídricos. Uno de
              los casos notorios es el abastecimiento del agua potable en la
              ciudad de Cajamarca, que a la fecha se realiza por turnos horarios
              (2-3 horas/día) y que dista de ser equitativo puesto que algunos
              sectores de la ciudad se ven menos afectados.
            </p>
            <p>
              La cuenca del río Ronquillo presenta un área de 42 km2 y se
              distribuye entre los 3000 hasta 3955 msnm. Toda la superficie de
              la cuenca está expuesta a precipitaciones promedio, mínimas y
              máximas anuales de 575 mm, 334 mm y 930 mm, respectivamente.
              (Figura 1). Las precipitaciones en la cuenca media y baja
              presentan una distribución unimodal, con las primeras lluvias
              ensetiembrey continúan hastamayo, además de ello la cuenca alta
              presenta eventos de lluvia horizontalde junio a setiembre que
              aportan un acumulado de 20 a 80 mm.
            </p>
            <p>
              A pesar del tamaño de la cuenca, la configuración climática,
              fisiográfica y grandes contrastes de la cobertura vegetal, la
              riqueza hídrica de la cuenca Ronquillo tradicionalmente desde
              época incaica abasteció de recurso hídrico a toda la poblaciónde
              Caxamarca/Cajamarca, y actualmente, alivia la situación crítica
              por la falta de agua en la ciudad de Cajamarca. Además de ello, el
              75.3% de población en Cajamarca es rural, y el 77% se abastecen de
              agua de calidad proveniente de los ecosistemas andinos - ver
              puntos verdes en la Figura 1 - durante la época de estiaje
              (Instituto Nacional de Estadística e Informática, Perú:
              <a href="http://www.inei.gob.pe" target="_blank"
                >http://www.inei.gob.pe</a
              >).
            </p>
          </Navtab>
          <Navtab id="paramo">
            <Title tag="h2">
              ¿Páramo, Jalca o Puna?
            </Title>
            <p>
              La delimitación del Páramo, la Jalca y la Puna es tema aún en
              debate. Si esta se realiza por su elevación, tiende a ser muy
              simplista pues podríamos encontrar ecosistemas páramos inmersos en
              la Jalca o Puna. La delimitación basada en la flora tiende a ser
              muy compleja debido a la gran biodiversidad endémica que se
              podrían encontrar en el Páramo. En el presente estudio se
              considerará a ambos, y se delimitará al Páramo en base al suelo
              Andosol y paramosol, ambos de origen volcánico con gran contenido
              de materia orgánica y arcillas, ácidos con alta saturación de
              bases y presentan déficit de nutrientes.
            </p>
            <Figure left="sm" maxWidth="700px">
              <Image
                :srcsets="[
                  '/images/proyectos/ecosistemas/paramo_ecosystem.png'
                ]"
                title="Funcionamiento de un ecosistema andino con y sin presencia de Páramos, resumen bibliográfico del ecosistema Páramo."
              />
              <template #figcaption>
                <b>Figura 2</b>. Funcionamiento de un ecosistema andino con y
                sin presencia de Páramos, resumen bibliográfico del ecosistema
                Páramo.
              </template>
            </Figure>
            <p>
              El Páramos es una colección de ecosistema de humedales alpino
              neotropical dentro del bioma de pastizales,y se clasifican en: (i)
              Páramos relativamente secos con precipitaciones entre 900 y 1200
              mm/año. (ii) Páramos húmedos con precipitaciones hasta 4000 mm/año
              y; (iii) Páramos muy húmedos con precipitaciones entre 4000 y 6000
              mm/año. Todos ellos tienen como característica en común las
              lluvias estacionales y lloviznas persistentes todo el año.
              Temperaturas promedio, en la noche entre 8 – 11 °C pero puede
              llegar -2 °C, durante el día puede alcanzar hasta 25 °C.
            </p>
            <p>
              El punto en común en las revisiones bibliográficas es la alta
              humedad relativa (entre 65 a 100%)que predomina en el Páramo.
              Dicho estado facilita la presencia de lluvia horizontal, la cual
              deposita agua en la vegetación por contacto físico, dando lugar a
              un permanente escurrimiento o goteo hacia el suelo. Otra
              característica en común son la presencia de fuertes vientos (20
              m/s) dominan el 65% del tiempo, este último en otros ecosistemas
              podría ser factor de sequedad, pero en los páramos es factor de
              conducción de nubes cargadas que precipitan.
            </p>
            <p>
              En general el páramo es una fuente constante de agua de calidad,
              sus descargas extremas se generan principalmente por el exceso de
              saturación, ya que el flujo Hortoniano es prácticamente
              inexistente.El rendimiento hídrico del páramo esta alrededor del
              57% y 68% en el caso de los páramos muy húmedos. Estos
              rendimientos son mucho mayores a los de los bosques húmedos
              tropicales con 35%, los bosques altoandinos o bosques de niebla
              con 54% y mucho mayor a los bosques secos con 19%.
            </p>
            <p>
              La escorrentía superficial es el principal vehículo del transporte
              de sedimentos y de la materia orgánica en la superficie del suelo
              (erosión del suelo). En la cadena de montañas de los andes, los
              páramos cobran mayor importancia debido a la presencia de las
              laderas muy empinadas (característica topográfica muy común a lo
              largo de los Andes). Debido al alto contenido de materia orgánica,
              estos poseen gran capacidad de almacenamiento de agua. Además, es
              un claro ejemplo de como un ecosistema (plantas y animales) se
              adaptó a las condiciones climáticas extremas de los Andes. No
              obstante, sus suelos y ecología son muy sensibles a pequeños
              cambios en el ambiente local. En el caso de los páramos húmedos
              (3600 mm/año), el 63% hace parte de la escorrentía directa y el
              14% se evapora.
            </p>
          </Navtab>
          <Navtab id="implementacion">
            <Title tag="h2">
              Implementación de una red de monitoreo meteorológico, hidrológico
              y erosión de los suelos
            </Title>
            <p>
              Las regiones de montaña tropical se caracterizan por su fuerte
              gradiente climática y la compleja topográfica; como consecuencia
              estudios locales de hidro-clima-sedimentológica requieren de una
              densa red de estaciones. Por lo antes mencionado, durante el 2016
              se llevó a cabo la instrumentación meteorológica e hidrológica de
              la cuenca del río Ronquillo ver Figura 1.
            </p>
          </Navtab>
          <Navtab id="resultados-esperados">
            <Title tag="h2">
              Resultados esperados
            </Title>
            <p>
              Puesta en valor del ecosistema Páramo mediante la caracterización
              y cuantificación de la interacción agua-suelo-planta en dicho
              ecosistema ejemplo:
            </p>
            <List marked>
              <li>
                Mitiga el impacto de eventos extremos inundaciones y sequias .
              </li>
              <li>
                Se viene analizando el caudal base que se origina en el
                ecosistema Páramo, con el fin de identificar el efecto buffer
                que se origina en las cabeceras de cuenca (almacena el recurso
                hídrico).
              </li>
              <li>
                Grandes almacenes de suelo, materia orgánica y carbono en
                cuencas fuertemente erodadas.
              </li>
              <li>
                Mediante el uso de trazadores isotópicos se bien cuantificando
                la capacidad de almacenamientos de los suelos en los ecosistemas
                Páramos.
              </li>
            </List>
          </Navtab>
          <Navtab id="equipo">
            <Title tag="h2">Equipo de trabajo</Title>
            <table-ui>
              <tbody>
                <tr>
                  <th>Grado</th>
                  <th>Nombres</th>
                  <th>Institución</th>
                  <th>Condición en el proyecto</th>
                </tr>
                <tr>
                  <td>Dr.</td>
                  <td>Yamina Silva Millones</td>
                  <td>IGP, Lima, Perú</td>
                  <td>Investigador</td>
                </tr>
                <tr>
                  <td>Dr.</td>
                  <td>Alejandro Alcántara Boza</td>
                  <td>UNMSM, Lima, Perú</td>
                  <td>Investigador</td>
                </tr>
                <tr>
                  <td>Dr.</td>
                  <td>Carlos Cabrera Carranza</td>
                  <td>UNMSM, Lima, Perú</td>
                  <td>Investigador</td>
                </tr>
                <tr>
                  <td>Dr.</td>
                  <td>Olivier Ribolzi</td>
                  <td>IRD, GET, Toulouse, Francia</td>
                  <td>Investigador</td>
                </tr>
                <tr>
                  <td>Dr.</td>
                  <td>Olivier Evrard</td>
                  <td>LSCE, Paris, Francia</td>
                  <td>Investigador</td>
                </tr>
                <tr>
                  <td>Dr.</td>
                  <td>Alex Taylor</td>
                  <td>Plymuth University, Reino Unido</td>
                  <td>Investigador</td>
                </tr>
                <tr>
                  <td>Dr.</td>
                  <td>Will Blake</td>
                  <td>Plymuth University, Reino Unido</td>
                  <td>Investigador</td>
                </tr>
                <tr>
                  <td>Ing.</td>
                  <td>Oscar Santiesteban KaneKo</td>
                  <td>E.P.S. SEDACAJ, Cajamarca, Perú</td>
                  <td>Soporte Logístico</td>
                </tr>
                <tr>
                  <td>Ing.</td>
                  <td>Yessica Martínez Quispe</td>
                  <td>IGP, Lima, Perú</td>
                  <td>Asistente en inv.</td>
                </tr>
                <tr>
                  <td>Adm.</td>
                  <td>Cesar Antonio Huincho Taipe</td>
                  <td>IGP, Lima, Perú</td>
                  <td>Administrador General</td>
                </tr>
                <tr>
                  <td>Bach.</td>
                  <td>Fernando J. Prudencio Paredes</td>
                  <td>UNMSM, Lima, Perú</td>
                  <td>Tesis de ingeniero</td>
                </tr>
                <tr>
                  <td>Bach.</td>
                  <td>Diana Violeta Díaz Llatas</td>
                  <td>UNC, Cajamarca, Perú</td>
                  <td>Tesis de ingeniero</td>
                </tr>
                <tr>
                  <td>Bach.</td>
                  <td>Jhon Orrillo Vigo</td>
                  <td>UNC, Cajamarca, Perú</td>
                  <td>Tesis de ingeniero</td>
                </tr>
                <tr>
                  <td>Bach.</td>
                  <td>Diana Violeta Díaz Llatas</td>
                  <td>UNC, Cajamarca, Perú</td>
                  <td>Tesis de ingeniero</td>
                </tr>
                <tr>
                  <td>Tec.</td>
                  <td>Andrea Malimba Alcántara</td>
                  <td>IGP, Lima, Perú</td>
                  <td>Laboratorista</td>
                </tr>
                <tr>
                  <td>Sr.</td>
                  <td></td>
                  <td>IGP, Cajamarca, Perú</td>
                  <td>Observador</td>
                </tr>
                <tr>
                  <td>Sr.</td>
                  <td>Rosas Alva Caja</td>
                  <td>IGP, Cajamarca, Perú</td>
                  <td>Observador</td>
                </tr>
                <tr>
                  <td>Sr.</td>
                  <td>Juan López Calua</td>
                  <td>IGP, Cajamarca, Perú</td>
                  <td>Observador</td>
                </tr>
                <tr>
                  <td>Sr.</td>
                  <td>Concepción Tanta Villanueva</td>
                  <td>IGP, Cajamarca, Perú</td>
                  <td>Observador</td>
                </tr>
                <tr>
                  <td>Sr.</td>
                  <td>María Teresa López Minchán</td>
                  <td>IGP, Cajamarca, Perú</td>
                  <td>Observador</td>
                </tr>
                <tr>
                  <td>Sr.</td>
                  <td>Víctor Chilón Chalan</td>
                  <td>IGP, Cajamarca, Perú</td>
                  <td>Observador</td>
                </tr>
                <tr>
                  <td>Sr.</td>
                  <td>Rotativo</td>
                  <td>E.P.S. SEDACAJ, Cajamarca, Perú</td>
                  <td>Observador</td>
                </tr>
              </tbody>
            </table-ui>
          </Navtab>
        </ColumnUi>
        <ColumnUi md="3">
          <Nav :items="navItems" title="Contenido" />
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import Trail from "@/components/common/Trail";
import Title from "@/components/ui/atoms/Title";
import List from "@/components/ui/objects/List";
import Container from "@/components/ui/objects/Container";
import TableUi from "@/components/ui/objects/TableUi";
import Figure from "@/components/ui/objects/Figure";
import Image from "@/components/ui/objects/Image";
import Nav from "@/components/ui/objects/Nav";
import Navtab from "@/components/ui/objects/Navtab";
import Row from "@/components/ui/atoms/Row";
import ColumnUi from "@/components/ui/atoms/ColumnUi";
export default {
  components: {
    Trail,
    Title,
    List,
    Container,
    TableUi,
    Figure,
    Image,
    Nav,
    Navtab,
    Row,
    ColumnUi
  },
  setup() {
    const navItems = [
      {
        path: "#introduccion",
        tag: "Introducción"
      },
      {
        path: "#laboratorio-experimental",
        tag: "Laboratorio experimental de ecosistemas andinos"
      },
      {
        path: "#sitio-estudio",
        tag: "Sitio de estudio"
      },
      {
        path: "#paramo",
        tag: "¿Páramo, Jalca o Puna?"
      },
      {
        path: "#implementacion",
        tag:
          "Implementación de una red de monitoreo meteorológico, hidrológico y erosión de los suelos"
      },
      {
        path: "#resultados-esperados",
        tag: "Resultados esperados"
      },
      {
        path: "#equipo",
        tag: "Equipo de trabajo"
      }
    ];
    return {
      navItems
    };
  }
};
</script>
